export default __webpack_public_path__ + "static/media/OSMOS_RUGGINE-MATT_60X120_16.75ab6924.jpg";